import { MediaFile, OwnerUser, Showroom } from '.';

export enum DiscountTypes {
  CashDiscount = 'Cash_Discount',
  PoolDiscount = 'Pool_Discount',
  TradeInAssist = 'Trade_In_Discount',
  Npc = 'NPC',
  CampaignDiscount = 'Campaign_Discount',
}

export enum CampaignStatus {
  Draft = 'Draft',
  Requested = 'Requested',
  Approved = 'Approved',
  Rejected = 'Rejected',
}

export interface CloneCampaign {
  validFrom: Date;
  validTo: Date;
}

export interface Campaign {
  _id?: string;
  title: string;
  validFrom: Date;
  validTo: Date;
  icon?: MediaFile;
  imageWeb?: MediaFile;
  campaignFor?: string;
  createdBy: OwnerUser;
  createdAt: Date;
  status?: string;
  approvedAt?: Date;
}

export interface CampaignDiscountData {
  _id?: string;
  campaignId: string;
  name: string;
  createdBy: OwnerUser;
  createdAt: Date;
  discounts?: CampaignDiscount[];
  variants?: string[];
  connectedCampaignTitle?: string;
  connectedCampaignIDs?: string[];
  campaignNameInArabic?: string;
}

export interface CashDiscountsData {
  _id?: string;
  campaignId: string;
  name: string;
  createdBy: OwnerUser;
  createdAt: Date;
  limits?: any[];
  showroomIds?: string[];
  showrooms?: Showroom[];
}

export interface NpcDiscountsData {
  _id?: string;
  campaignId: string;
  title: string;
  createdBy: OwnerUser;
  createdAt: Date;
  limits?: any[];
  showroomIds?: string[];
  showrooms?: Showroom[];
  ceilingPrices?: any[];
}

export interface TradeInDiscountsData {
  _id?: string;
  campaignId: string;
  name: string;
  createdBy: OwnerUser;
  createdAt: Date;
  limits?: any[];
  showroomIds?: string[];
  showrooms?: Showroom[];
}
export interface PoolDiscountsData {
  _id?: string;
  campaignId: string;
  name: string;
  createdBy: OwnerUser;
  createdAt: Date;
  limits?: any[];
  pools?: any[];
}

export interface CampaignDetail {
  campaignData?: Campaign;
  campaignDiscountData?: CampaignDiscountData[];
  cashDiscountData?: CashDiscountsData;
  tradeInDiscountData?: TradeInDiscountsData;
  poolDiscountData?: CashDiscountsData;
  npcData?: NpcDiscountsData;
}

export interface CampaignGrouped {
  upcoming: Campaign[];
  current: Campaign[];
  past: Campaign[];
}

export interface CreateCampaignDiscount {
  name?: string;
  discountType?: string;
  campaignNameInArabic?: string;
}

export interface CampaignEntityType {
  entityID: number;
  entityName: string;
}

export interface CampaignEntity {
  productID: number;
  productTitle: string;
  optionsList: CampaignEntityOptions[];
  discountAmount?: number;
  bankFinanceRate?: number;
  couponEntityType?: string;
}

export interface CampaignEntityOptions {
  productOptionID: number;
  productOptionName: string;
  priceType: string;
  priceValue: number;
  productOptionProductPrice: number;
}

export interface CampaignDiscount {
  _id?: string;
  currentCampaignDiscountId?: string;
  campaignId?: string;
  campaignDiscountId?: string;
  currentCampaignId?: string;
  campEntityID: number;
  campProductID?: number;
  campProductOptID?: number;
  campDiscountTitle?: string;
  campDiscountType?: string;
  campDiscountValue?: number;
  campDiscountAppliedCart?: boolean;
  campaignDiscountApplyCartText?: string;
  campDiscountDiffVariant?: boolean;
  campCashback?: number;
  netPriceCeiling?: boolean;
  netPriceType?: string;
  netPriceValue?: number;
  noOfCouponOffered?: number;
  couponMinDiscount?: number;
  couponMaxDiscount?: number;
  numOfFreeEmi?: number;
  campInternalPriceType?: string;
  campInternalPrice?: number;
  campOriginalPrice?: number;
  currentInrerestRate?: number;
  internalRate?: number;
  downPayment?: string;
  tenureDiscount?: boolean;
  tenureInMonths?: string;
  documentsRequired?: boolean;
  financeCalculationAtVehiclePrice?: boolean;
  excludedDiscounts?: {
    discountType: string;
    excludedDiscountIds: string[];
  }[];
  updateType?: string;
  createdAt?: Date;
  documentsRequiredType?: string;
  mandatoryDocument?: string[];
  optionalDocument?: string[];
  price?: number;
  campEntityName?: string;
  campProductName?: string;
  campProductOptName?: string;
  campDiscountTitleInArabic?: string;
}

export interface DocumentsList {
  crmDocumentID: number;
  documentName: string;
}

export interface ConnectedCampaign {
  connectedCampaignTitle: string;
  connectedCampaignIDs?: string[];
}

export interface EditCampaignDiscount {
  name?: string;
}
